import React from 'react';
import LoaderSpinner from 'components/elements/LoaderSpinner';

import { StyledLoader } from './styles';

const Loader = () => (
  <StyledLoader>
    <LoaderSpinner color="#266ff2" />
  </StyledLoader>
);

export default Loader;
